import { ExperiencePerformanceTypes } from '@atlassian/ufo-experimental';
import { isInitialPageLoad } from '../../../../utils/is-initial-page-load';
import { customTimings } from './custom';
import { ssrTimings } from './ssr';
export const appTimings = (data, ssrConfig) => {
  const explicitTimings = data.performanceType === ExperiencePerformanceTypes.PageLoad && data.explicitTimings || null;
  const timings = customTimings(data);
  const ssr = isInitialPageLoad(data) ? ssrTimings(ssrConfig) : null;
  const timingsApp = (explicitTimings || timings || ssr) && {
    ...explicitTimings,
    ...timings,
    ...ssr
  };
  if (!timingsApp || Object.keys(timingsApp).length === 0) {
    return null;
  }
  return {
    'timings:app': timingsApp
  };
};